import { Plus } from 'lucide-react';
import { forwardRef } from 'react';

interface FloatingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
}

const FloatingButton = forwardRef<HTMLButtonElement, FloatingButtonProps>(
  ({ onClick, ...prop }, ref) => {
    return (
      <button
        ref={ref}
        aria-label="New inspection or bucket"
        className="fixed right-5 bottom-5 flex size-12 items-center justify-center rounded-full bg-primaryColor text-white shadow-lg transition-colors hover:bg-brand"
        onClick={onClick}
        {...prop}
      >
        <Plus color="white" size={30} />
      </button>
    );
  },
);

export default FloatingButton;
